module.exports = __webpack_public_path__ + "img/10.023d7131.jpg";